(function () {
  if (window.etFreeShippingBarInit) return;
  window.etFreeShippingBarInit = true;

  var REVEAL_CLASS = 'et-test-global-001';

  function isActive() {
    return document.body.classList.contains(REVEAL_CLASS) || (window.Shopify && window.Shopify.designMode);
  }

  function money(cents, format, symbol) {
    var value = typeof window.formatMoney === 'function'
      ? window.formatMoney(cents, format)
      : (cents / 100).toFixed(2).replace('.', ',');
    if (symbol && String(value).indexOf(symbol) === -1) value = symbol + value;
    return value;
  }

  function render(subtotal) {
    document.querySelectorAll('[data-et-fsb]').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold || isNaN(subtotal)) return;

      var remaining = Math.max(threshold - subtotal, 0);
      var progress = Math.min((subtotal / threshold) * 100, 100);
      var state = subtotal <= 0 ? 'empty' : remaining === 0 ? 'reached' : 'progress';

      bar.dataset.state = state;
      bar.querySelectorAll('[data-et-fsb-remaining]').forEach(function (el) {
        el.textContent = money(remaining, bar.dataset.moneyFormat, bar.dataset.currencySymbol);
      });

      var track = bar.querySelector('.et-free-shipping-bar__track');
      var fill = bar.querySelector('.et-free-shipping-bar__fill');
      if (track) track.setAttribute('aria-valuenow', Math.round(progress));
      if (fill) fill.style.width = progress + '%';
    });
  }

  /* Progress counts only items that require shipping — Verzendbescherming
     (handle shipping-insurance) must not push the bar over the threshold.
     The handle check stays as a fallback in case the insurance app ever
     flips the product back to "physical". */
  function shippableSubtotal(cart) {
    var subtotal = cart.items_subtotal_price;
    cart.items.forEach(function (item) {
      if (item.requires_shipping === false || item.handle === 'shipping-insurance') {
        subtotal -= item.final_line_price || 0;
      }
    });
    return Math.max(subtotal, 0);
  }

  function update(cart) {
    if (!isActive() || !cart || typeof cart.items_subtotal_price !== 'number') return;
    if (!Array.isArray(cart.items)) {
      refresh();
      return;
    }
    render(shippableSubtotal(cart));
  }

  function refresh() {
    if (!isActive()) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(update)
      .catch(function () {});
  }

  function subscribe() {
    var events = window.FoxThemeEvents;
    if (!events || typeof events.subscribe !== 'function') return;
    events.subscribe('ON_CART_UPDATED', update);
    events.subscribe('ON_ITEM_ADDED', refresh);
  }

  if (window.FoxThemeEvents) {
    subscribe();
  } else {
    document.addEventListener('DOMContentLoaded', subscribe);
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  if (!document.body.classList.contains(REVEAL_CLASS)) {
    var observer = new MutationObserver(function () {
      if (document.body.classList.contains(REVEAL_CLASS)) {
        observer.disconnect();
        refresh();
      }
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-et-fsb]')) refresh();
  });
})();
